
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NoRecords extends Vue {
    @Prop({ default: 10 }) colspan!: number;
}
